import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
import { cardDefaultValue } from '@entities/card/model';
export const ACTION_TYPES = {
    FETCH_CARDS_LIST: 'card/FETCH_CARDS_LIST',
    FETCH_CARD: 'card/FETCH_CARD',
    CREATE_CARD: 'card/CREATE_CARD',
    UPDATE_CARD: 'card/UPDATE_CARD',
    DELETE_CARD: 'card/DELETE_CARD',
    SUSPEND_CARD: 'card/SUSPEND_CARD',
    UNSUSPEND_CARD: 'card/UNSUSPEND_CARD',
    RESET: 'card/RESET',
    RESET_ENTITY: 'card/RESET_ENTITY',
};
const listApiUrl = 'api/cards';
const apiUrl = 'api/cards';
const initialState = {
    loading: false,
    loadingEntity: false,
    errorMessage: null,
    entities: [],
    entity: cardDefaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARDS_LIST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.FETCH_CARD):
            return {
                ...state,
                errorMessage: null,
                loadingEntity: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD):
        case REQUEST(ACTION_TYPES.UPDATE_CARD):
        case REQUEST(ACTION_TYPES.DELETE_CARD):
        case REQUEST(ACTION_TYPES.SUSPEND_CARD):
        case REQUEST(ACTION_TYPES.UNSUSPEND_CARD):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARDS_LIST):
            return {
                ...state,
                loading: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD):
            return {
                ...state,
                loadingEntity: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.CREATE_CARD):
        case FAILURE(ACTION_TYPES.UPDATE_CARD):
        case FAILURE(ACTION_TYPES.DELETE_CARD):
        case FAILURE(ACTION_TYPES.SUSPEND_CARD):
        case FAILURE(ACTION_TYPES.UNSUSPEND_CARD):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARDS_LIST): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list,
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.FETCH_CARD):
            return {
                ...state,
                loadingEntity: false,
                entity: action.payload.data,
            };
        case SUCCESS(ACTION_TYPES.CREATE_CARD):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD):
        case SUCCESS(ACTION_TYPES.DELETE_CARD):
        case SUCCESS(ACTION_TYPES.SUSPEND_CARD):
        case SUCCESS(ACTION_TYPES.UNSUSPEND_CARD):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
            };
        case ACTION_TYPES.RESET_ENTITY:
            return {
                ...state,
                entity: cardDefaultValue,
                loadingEntity: false,
            };
        case ACTION_TYPES.RESET:
            return { ...initialState };
        default:
            return state;
    }
};
/** Omit `params` for legacy unpaginated list (e.g. dropdowns). Pass `{}` or `{ page, size }` for server pagination. */
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARDS_LIST,
    payload: cmsHttp().get(listApiUrl, params === undefined
        ? undefined
        : {
            params: buildSpringPageParams(params),
            paramsSerializer: { indexes: null },
        }),
});
export const getEntity = (id) => ({
    type: ACTION_TYPES.FETCH_CARD,
    payload: cmsHttp().get(`${apiUrl}/${id}`),
});
export const createEntity = (body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.CREATE_CARD,
    payload: cmsHttp().post(apiUrl, body),
});
export const updateEntity = (id, body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.UPDATE_CARD,
    payload: cmsHttp().patch(`${apiUrl}/${id}`, body),
});
export const deleteEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.DELETE_CARD,
    payload: cmsHttp().delete(`${apiUrl}/${id}`),
});
/** `reason` is sent as query param per API: `POST /api/{id}/suspend?reason=...` */
export const suspendEntity = (id, reason) => async (dispatch) => dispatch({
    type: ACTION_TYPES.SUSPEND_CARD,
    payload: cmsHttp().post(`api/${id}/suspend`, undefined, {
        params: { reason },
    }),
});
/** Optional `reason` as query param: `POST /api/{id}/unsuspend?reason=...` */
export const unsuspendEntity = (id, reason) => async (dispatch) => dispatch({
    type: ACTION_TYPES.UNSUSPEND_CARD,
    payload: cmsHttp().post(`api/${id}/unsuspend`, undefined, {
        params: reason?.trim() ? { reason: reason.trim() } : undefined,
    }),
});
export const resetEntity = () => ({
    type: ACTION_TYPES.RESET_ENTITY,
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
